import { axios } from "@Root/API";

export const createFinancialSupport = data => {
  return axios.post("create/financial-support", data);
};
